import React, { useEffect, useState } from 'react';
import { FiStar, FiCheck, FiX, FiTrash2, FiImage, FiClock } from 'react-icons/fi';
import { adminApi } from '../adminApi';
import { showDelete } from '../utils/dialog';
import './AdminReviews.css';

const TABS = [
  { key: false,     label: 'Pending',  color: '#f59e0b' },
  { key: true,      label: 'Approved', color: '#22c55e' },
  { key: undefined, label: 'All',      color: '#94a3b8' },
];

const LABELS = ['', 'Poor', 'Fair', 'Good', 'Very Good', 'Excellent'];

export default function AdminReviews() {
  const [tab,     setTab]     = useState(false);
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [lightbox, setLightbox] = useState(null);

  useEffect(() => { load(); }, [tab]);

  const load = async () => {
    setLoading(true);
    try {
      const r = await adminApi.getReviews(tab);
      setReviews(r.data);
    } catch {}
    finally { setLoading(false); }
  };

  const approve = async (id) => {
    await adminApi.approveReview(id);
    setReviews(rv => rv.map(r => r.id === id ? { ...r, approved: true } : r));
    if (tab === false) setReviews(rv => rv.filter(r => r.id !== id));
  };

  const reject = async (id) => {
    await adminApi.rejectReview(id);
    setReviews(rv => rv.map(r => r.id === id ? { ...r, approved: false } : r));
    if (tab === true) setReviews(rv => rv.filter(r => r.id !== id));
  };

  const del = async (id) => {
    if (!await showDelete('Delete this review permanently?')) return;
    await adminApi.deleteReview(id);
    setReviews(rv => rv.filter(r => r.id !== id));
  };

  return (
    <div className="ar-page">
      <div className="ar-header">
        <div>
          <h1 className="ar-title">Manage Reviews</h1>
          <p className="ar-sub">Approve or remove customer reviews before they appear on the store.</p>
        </div>
      </div>

      <div className="ar-tabs">
        {TABS.map(t => (
          <button
            key={String(t.key)}
            className={`ar-tab ${tab === t.key ? 'active' : ''}`}
            style={{ '--tc': t.color }}
            onClick={() => setTab(t.key)}
          >
            {t.label}
          </button>
        ))}
      </div>

      {loading ? (
        <div className="ar-loading">
          {[1,2,3].map(i => <div key={i} className="ar-skeleton" />)}
        </div>
      ) : reviews.length === 0 ? (
        <div className="ar-empty">
          <FiClock size={36} />
          <p>No {tab === false ? 'pending' : tab === true ? 'approved' : ''} reviews</p>
        </div>
      ) : (
        <div className="ar-list">
          {reviews.map(rv => (
            <div key={rv.id} className={`ar-card ${rv.approved ? 'ar-card-approved' : 'ar-card-pending'}`}>
              <div className="ar-card-top">
                <div className="ar-avatar">{(rv.reviewer_name || 'A')[0].toUpperCase()}</div>
                <div className="ar-meta">
                  <span className="ar-name">{rv.reviewer_name || 'Customer'}</span>
                  <div className="ar-stars">
                    {[1,2,3,4,5].map(s => (
                      <FiStar key={s} size={12} className={s <= rv.rating ? 'ar-star-on' : 'ar-star-off'} />
                    ))}
                    <span className="ar-rating-label">{LABELS[rv.rating]}</span>
                  </div>
                </div>
                <span className="ar-date">
                  {new Date(rv.created_at).toLocaleDateString('en-PK', { day:'numeric', month:'short', year:'numeric' })}
                </span>
                <span className={`ar-badge ${rv.approved ? 'ar-badge-approved' : 'ar-badge-pending'}`}>
                  {rv.approved ? 'Approved' : 'Pending'}
                </span>
              </div>

              <p className="ar-comment">{rv.comment}</p>

              {rv.image_url && (
                <img
                  src={rv.image_url}
                  alt="review"
                  className="ar-review-img"
                  onClick={() => setLightbox(rv.image_url)}
                />
              )}

              <div className="ar-actions">
                {!rv.approved && (
                  <button className="ar-btn ar-btn-approve" onClick={() => approve(rv.id)}>
                    <FiCheck size={14} /> Approve
                  </button>
                )}
                {rv.approved && (
                  <button className="ar-btn ar-btn-reject" onClick={() => reject(rv.id)}>
                    <FiX size={14} /> Unapprove
                  </button>
                )}
                <button className="ar-btn ar-btn-delete" onClick={() => del(rv.id)}>
                  <FiTrash2 size={14} /> Delete
                </button>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Lightbox */}
      {lightbox && (
        <div className="ar-lightbox" onClick={() => setLightbox(null)}>
          <img src={lightbox} alt="full" />
        </div>
      )}
    </div>
  );
}
